import { createSelector } from '@ngrx/store';
import { TMMFactoryState } from './factory.models';
import { TMachineMaintenanceState } from '../reducers';

export const getFactoryState = (state: TMachineMaintenanceState) => state.factoryInfo;

export const getFactoryId = createSelector(getFactoryState, (state: TMMFactoryState) => state.factoryId);

export const getUserName = createSelector(getFactoryState, (state: TMMFactoryState) => state.userName);
